import { SaveButton } from "components/Buttons"
import {
  CheckboxField,
  SingleSelectField,
  TextField,
  RadioField,
} from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import {
  arrayPush,
  change,
  Field,
  FieldArray,
  FormSection,
  formValueSelector,
  initialize,
  reduxForm,
} from "redux-form"
import { renderForm, renderMultiWebLinkForm } from "./utils"
import {
  addWebLink,
  getWebLink,
  resetWebLink,
  updateWebLink,
} from "store/actions"
import {
  mapApiToWebLinkForm,
  mapUpdatedWebLinkToApi,
  mapWebLinkToApiForm,
} from "../utils"
import validate from "./webLinkValidation"
import PropTypes from "prop-types"
import Preview from "./preview"
import { LoadingIndicator } from "components/LoadingIndicator"

let WebLink = props => {
  useEffect(() => {
    if (props.feature.entity_id) {
      props.getWebLink(props.feature.entity_id)
    }
    return () => {
      props.resetWebLink()
    }
  }, [])

  useEffect(() => {
    if (props.webLink) {
      props.initializeForm(mapApiToWebLinkForm(props.webLink))
    }
  }, [props.webLink])

  const submitHandler = data => {
    if (!props.feature.entity_id) {
      const [container, links] = mapWebLinkToApiForm({
        ...data.web_link_form,
        eventId: props?.selectedEvent?.id,
        name: data.web_link_form?.name || props.feature.label,
        menu_feature: 1,
        vendorId: props.vendorId,
        label: data.web_link_form?.name || props.feature.label,
        menu_item_id: props.feature.id,
        order: 0,
        status: 0,
      })
      props.addWebLink({ container, links })
    } else {
      const [updatedLinks, newLinks, container, deletableLinkIds] =
        mapUpdatedWebLinkToApi(
          { ...data.web_link_form, name: props.feature.label },
          props.webLink
        )
      props.updateWebLink({
        updatedLinks,
        newLinks,
        container,
        deletableLinkIds,
      })
    }
  }

  return (
    <FormSection name={props.form}>
      {props?.loading ? (
        <LoadingIndicator />
      ) : (
        <Card>
          <CardBody className="shadow-sm">
            <Row className="mb-3">
              <Col>
                <h3>{props.feature.label}</h3>
              </Col>
              {props.isListItem && (
                <Col xs="auto">
                  <SaveButton
                    type="button"
                    content="Cancel"
                    color="light"
                    onClick={props.backButtonHandler}
                  />
                </Col>
              )}
              <Col xs="auto">
                <SaveButton
                  content="Save"
                  type="button"
                  onClick={
                    props.isListItem
                      ? props.handleSubmit(props.handleAddListItem)
                      : props.handleSubmit(submitHandler)
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    <h4>SELECT WEB LINK SCREEN TYPE</h4>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col xs={12} className="my-1">
                        <Field
                          name="webLinkScreenType"
                          value="1"
                          type="radio"
                          label="Single Web Link Screen - Add one link"
                          component={RadioField}
                          onChange={(e, newValue) => {
                            if (newValue === "1") {
                              props.change("web_link_form.linkType", "1")
                            }
                          }}
                        />
                      </Col>
                      <Col xs={12} className="my-1">
                        <Field
                          name="webLinkScreenType"
                          value="2"
                          type="radio"
                          label="Multi-Web Link Screen - Add up to 4 links"
                          component={RadioField}
                          onChange={() => {
                            if (!props.multiWebLinks) {
                              props.change("web_link_form.multiWebLink", [
                                { linkIcon: "81", linkType: "1" },
                                { linkIcon: "81", linkType: "1" },
                              ])
                            }
                          }}
                        />
                      </Col>
                      {props.webLinkScreenType === "2" && (
                        <Col xs={12} className="mt-1">
                          Drag & drop{" "}
                          <i className="bx bx-sm bx-menu align-middle" /> to
                          reorder links, then click on "Save".
                        </Col>
                      )}
                    </Row>
                  </CardBody>
                </Card>
                {props.webLinkScreenType === "1" ? (
                  <Card>
                    <CardHeader>
                      <h4>
                        {props.isListItem
                          ? "CREATE A NAME FOR THE WEB LINK AND ADD A WEB URL, PHONE NUMBER OR DEEPLINK"
                          : "ADD A WEB URL, PHONE NUMBER OR DEEPLINK"}
                      </h4>
                    </CardHeader>
                    <CardBody>
                      {props.isListItem && (
                        <React.Fragment>
                          <Row className="mb-2">
                            <Col>
                              <Field
                                name="name"
                                component={TextField}
                                label="Web link Name"
                              />
                            </Col>
                          </Row>
                          <hr />
                        </React.Fragment>
                      )}
                      <Row>
                        <Col>
                          <Field
                            name="linkType"
                            value="1"
                            type="radio"
                            label="Website URL"
                            component={RadioField}
                          />
                        </Col>
                        <Col>
                          <Field
                            name="linkType"
                            value="2"
                            type="radio"
                            label="IOS/Android deeplink"
                            component={RadioField}
                          />
                        </Col>
                        <Col>
                          <Field
                            name="linkType"
                            value="3"
                            type="radio"
                            label="Phone"
                            component={RadioField}
                          />
                        </Col>
                      </Row>
                      {renderForm(props?.linkType)}
                    </CardBody>
                  </Card>
                ) : (
                  <>
                    {props.isListItem && (
                      <Card>
                        <CardHeader>
                          <h4>CREATE A TITLE FOR YOUR MULTI-WEB LINK SCREEN</h4>
                        </CardHeader>
                        <CardBody>
                          <Row>
                            <Col>
                              <Field
                                name="name"
                                component={TextField}
                                label="Screen Title"
                              />
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    )}
                    <Row className="my-3">
                      <Col>
                        <FieldArray
                          name="multiWebLink"
                          component={renderMultiWebLinkForm}
                          menuIcons={props.menuIcons}
                        />
                      </Col>
                    </Row>
                    {props.multiWebLinks && props.multiWebLinks.length < 4 && (
                      <Row>
                        <Col>
                          <h5
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              props.addForm(
                                FORM_NAMES.WEB_LINK,
                                "web_link_form.multiWebLink",
                                {
                                  linkIcon: "81",
                                  linkType: "1",
                                }
                              )
                            }}
                          >
                            + Add Another Web Link to this Screen
                          </h5>
                        </Col>
                      </Row>
                    )}
                  </>
                )}

                <Row className="my-2">
                  <Col className="d-flex justify-content-center">
                    <SaveButton
                      type="button"
                      content="Save"
                      onClick={
                        props.isListItem
                          ? props.handleSubmit(props.handleAddListItem)
                          : props.handleSubmit(submitHandler)
                      }
                    />
                  </Col>
                </Row>
              </Col>
              <Col xl={4} className="mt-4 custom-features-preview">
                <Preview
                  menu_bg_color={props.design?.menu_bg_color}
                  menu_font_color={props.design?.menu_font_color}
                  label={props?.formValues?.name || props?.feature?.label}
                  webLinkScreenType={props.webLinkScreenType}
                  multiWebLinks={props.multiWebLinks}
                  menuIcons={props.menuIcons}
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}
    </FormSection>
  )
}

WebLink = reduxForm({
  form: FORM_NAMES.WEB_LINK,
  validate,
  initialValues: {
    web_link_form: {
      webLinkScreenType: "1",
      multiWebLink: [
        { linkIcon: "81", linkType: "1" },
        { linkIcon: "81", linkType: "1" },
      ],
      linkType: "1",
    },
  },
})(WebLink)

const selector = formValueSelector(FORM_NAMES.WEB_LINK)

const mapStateToProps = state => ({
  webLinkScreenType: selector(state, "web_link_form.webLinkScreenType"),
  multiWebLinks: selector(state, "web_link_form.multiWebLink"),
  vendorId: state.Login.vendorId,
  userId: state.Login.authUser.id,
  selectedEvent: state.experiences.selectedEvent,
  menuIcons: state.menuFeatures.menuIcons,
  webLink: state.WebLink.webLink,
  loading: state.WebLink.loading,
  formValues: selector(state, "web_link_form"),
  linkType: selector(state, "web_link_form.linkType"),
})

const mapDispatchToProps = dispatch => ({
  addForm: (form, field, values) => dispatch(arrayPush(form, field, values)),
  initializeForm: values =>
    dispatch(
      initialize(FORM_NAMES.WEB_LINK, {
        web_link_form: values,
      })
    ),
  addWebLink: values => dispatch(addWebLink(values)),
  getWebLink: values => dispatch(getWebLink(values)),
  resetWebLink: () => dispatch(resetWebLink()),
  change: (field, value) =>
    dispatch(change(FORM_NAMES.WEB_LINK, `${field}`, value)),
  updateWebLink: values => dispatch(updateWebLink(values)),
})

WebLink.propTypes = {
  feature: PropTypes.object,
  handleAddListItem: PropTypes.func,
  isListItem: PropTypes.bool,
  backButtonHandler: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(WebLink)
